import { useContext } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import Box from "@mui/material/Box";
import MUIStepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import stepperCheckmarkUrl from "@/assets/stepper_checkmark.svg?url";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";

import { STEPS } from "@/constants/onboarding";
import { OnboardingContext } from "@/context/OnboardingContext";

// import Typography from "@mui/material/Typography";

const Check = () => (
  <img
    src={stepperCheckmarkUrl}
    alt=""
    width={18}
    height={18}
    style={{ display: "block" }}
  />
);

const CustomConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#093844",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#093844",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "#C0C4CF",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const CustomStepIconRoot = styled("div")(({ ownerState }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: 18,
  width: 18,
  borderRadius: "50%",
  background: "#C0C4CF",
  color: "#FFFFFF",
  "& .CustomStepIcon-completedIcon": {
    background: "transparent",
    borderRadius: "50%",
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    zIndex: 1,
    fontSize: 10,
    overflow: "hidden",
  },
  "& .CustomStepIcon-circle": {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    fontSize: "9px",
    fontWeight: 700,
    justifyContent: "center",
    ...(ownerState.active && {
      background: "#093844",
      color: "#50CFF1",
      position: "relative",
      "&::after": {
        content: '""',
        position: "absolute",
        top: 5,
        left: 5,
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: "#50CFF1",
      },
    }),
    borderRadius: "50%",
    // backgroundColor: "currentColor",
    position: "relative",
  },
}));

const CustomStepIcon = (props) => {
  const { active, completed, icon } = props;
  return (
    <CustomStepIconRoot ownerState={{ active, icon }}>
      {completed ? (
        <div className="CustomStepIcon-completedIcon">
          <Check />
        </div>
      ) : (
        <div className="CustomStepIcon-circle">{active ? "" : icon}</div>
      )}
    </CustomStepIconRoot>
  );
};

CustomStepIcon.propTypes = {
  active: PropTypes.bool,
  icon: PropTypes.number,
  completed: PropTypes.bool,
};

const Stepper = () => {
  const { actualStep: activeStep, setActualStep, setActualSubStep, maxStep } =
    useContext(OnboardingContext);
  return (
    <Box sx={{ flexGrow: 4, maxWidth: "480px", marginLeft: 'auto' }}>
      <MUIStepper activeStep={activeStep} connector={<CustomConnector />}>
        {STEPS.map(({ title, skipStepper }, i) => {
          if (skipStepper) return null;
          const stepProps = {};
          return (
            <Step
              key={title}
              {...stepProps}
              onClick={() => {
                if (i > maxStep) return
                setActualStep(i)
                setActualSubStep(0)
              }}
              disabled={false}
            >
              <StepLabel
                StepIconComponent={CustomStepIcon}
                sx={{
                  cursor: i > maxStep? "default" : "pointer",
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    lineHeight: "24px",
                    fontWeight: i <= activeStep ? 700 : 400,
                    color: i <= activeStep ? "#093844" : "#656B77",
                  }}
                >
                  {title}
                </Typography>
              </StepLabel>
            </Step>
          );
        })}
      </MUIStepper>
    </Box>
  );
};

Stepper.propTypes = {
  activeStep: PropTypes.number,
};
export default Stepper;
